export default __webpack_public_path__ + "images/26c95bf380884877cdd13d1406e524a6-dotted-line.webp";